// Central config for all WhatsApp entry points. One number, one place.
//
// Prefilled messages are deliberate ROUTING KEYS: each contains an
// unambiguous keyword that Zoho Desk assignment rules match on to
// auto-assign the ticket. Change wording only alongside the matching Desk rule.

export const WHATSAPP_NUMBER_E164 = "+441244955444";
export const WHATSAPP_NUMBER_WA = "441244955444";
export const WHATSAPP_NUMBER_DISPLAY = "01244 955 444";

// Mon–Fri 09:00–17:00 Europe/London, DST-safe via Intl.
export function isWithinBusinessHours(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    weekday: "short",
    hour: "numeric",
    hour12: false,
  }).formatToParts(date);
  const weekday = parts.find((p) => p.type === "weekday")?.value;
  const hour = Number(parts.find((p) => p.type === "hour")?.value);
  return ["Mon", "Tue", "Wed", "Thu", "Fri"].includes(weekday) && hour >= 9 && hour < 17;
}

// Placement → prefilled first message. Keyword in each is the Desk routing key.
const MESSAGES = {
  float: "Hi CanDo — I've got a question about card payments.",
  navbar: "Hi CanDo — I've got a quick question.",
  footer: "Hi CanDo — I've got a question.",
  contact: "Hi CanDo — I'd like to speak to someone about payments.",
  home_support: "Hi CanDo — I'd like to ask about your support.",
  card_machines: "Hi CanDo — I'm interested in a card machine for my business.",
  online: "Hi CanDo — I'm looking at taking payments online.",
  epos: "Hi CanDo — I'd like to know more about your EPOS systems.",
  pricing: "Hi CanDo — can you check whether I'm overpaying on card fees?",
  statement: "Hi CanDo — I'd like you to review my current statement.",
  support: "Hi CanDo — I'm an existing customer and need some help.",
};

export function whatsAppMessage(placement = "float") {
  return MESSAGES[placement] || MESSAGES.float;
}

export function whatsAppUrl(placement = "float") {
  return `https://wa.me/${WHATSAPP_NUMBER_WA}?text=${encodeURIComponent(
    whatsAppMessage(placement)
  )}`;
}

export function whatsAppReplyPromise(date = new Date()) {
  return isWithinBusinessHours(date)
    ? "Typically replies in under 4 minutes"
    : "We'll reply first thing next working day";
}
